

const sumQuestionTotal = (str) => {
    let newStr = JSON.parse(str);
    var count = 0;
    for (var key in newStr) {
        if (newStr.hasOwnProperty(key)) {
            if (key.search("answer")) {
                count = count + 1;
            }
        }
    }
    return count;
}

const sumCorrectTotal = (str) => {
    let newStr = JSON.parse(str);
    var count = 0;
    for (var key in newStr) {
        if (newStr.hasOwnProperty(key)) {
            if (newStr[key]['is_correct'] == 1) {
                count = count + 1;
            }
        }
    }
    return count;
}

const checkCorrect = (str, id) => {
    let newStr = JSON.parse(str);
    var isCorrect = false;
    for (var key in newStr) {
        if (newStr.hasOwnProperty(key)) {
            var newKey = "answer_" + id;
            if (key.search(newKey)) {
                if (newStr[newKey] && newStr[newKey]['is_correct'] == 1) {
                    isCorrect = true;
                }
            }
        }
    }
    return isCorrect;
}

const checkAnswerWithScore = (str, id) => {
    let newStr = JSON.parse(str);
    var answer = null;
    for (var key in newStr) {
        if (newStr.hasOwnProperty(key)) {
            var newKey = "answer_" + id;
            if (key.search(newKey)) {
                answer = newStr[newKey];
            }
        }
    }
    return answer;
}

const totalCorrectScore = (str, id) => {
    let newStr = JSON.parse(str);
    var sum = 0;
    for (var key in newStr) {
        if (newStr.hasOwnProperty(key)) {
            if (newStr.hasOwnProperty(key)) {
                if (newStr[key]['is_correct'] == 1) {
                    sum += newStr[key]['score'];
                }
            }
        }
    }
    return sum;
}

const sumSortType = (array, type) => {
    var sum = 0;
    if (array) {
        for (let index = 0; index < array.length; index++) {
            array[index]?.section_item?.map((item) => {
                if (type && item?.type === type) {
                    sum = sum + 1;
                }
                else if (!type) {
                    sum = sum + 1;
                }
            })
        }
    }
    return sum;
}

const checkSection = (section, idd) => {
    let find = section?.findIndex((item) => {
        return item.course_section_item_id === idd;
    });
    if (find == -1) {
        return false;
    } else {
        return true;
    }
};

const getIframeLink = (content) => {
    return content?.split('src="')[1]?.split('"')[0];
}

export {
    sumQuestionTotal,
    sumCorrectTotal,
    checkCorrect,
    checkAnswerWithScore,
    totalCorrectScore,
    sumSortType,
    checkSection,
    getIframeLink
}